<template>
  <a-tooltip @tooltip-close="$emit('tooltip-close')">
    <template #title>
      <template v-if="userSubscribePerformed && userAlreadySubscribed">
        {{ $translate('profile.actionResults.subscribed') }}
      </template>
      <template v-else-if="userSubscribePerformed">
        {{ $translate('profile.actionResults.userSubscribed') }}
      </template>
      <template v-else-if="alreadyPerformed">
        {{ $translate('profile.actionResults.postAlreadySubscribed') }}
      </template>
      <template v-else>
        {{ $translate('profile.actionResults.subscribed') }}
      </template>
    </template>
    <template #text>
      <div class="anz-mt-xs">
        <template v-if="userSubscribePerformed && userAlreadySubscribed">
          {{ $translate('profile.actionResults.userAlreadySubscribedText') }}
          <a-button
            className="anz-link anz-color-primary anz-font-bold anz-link-underline"
            :href="generateSubscribersRoute(currentUser)"
            add-href
            :title="
              $translate('profile.actionResults.userSubscribedUsersRoute')
            "
          ></a-button>
        </template>
        <template v-else-if="userSubscribePerformed">
          {{ $translate('profile.actionResults.userSubscribedText') }}
          <a-button
            className="anz-link anz-color-primary anz-font-bold anz-link-underline"
            :href="generateSubscribersRoute(currentUser)"
            add-href
            :title="
              $translate('profile.actionResults.userSubscribedUsersRoute')
            "
          ></a-button>
        </template>
        <template v-else>
          {{ $translate('post.actionResults.alreadySubscribedText') }}
        </template>
      </div>
    </template>
    <template #action v-if="!userSubscribePerformed">
      <a-button
        className="anz-btn anz-btn-primary anz-btn-s anz-fc-icon anz-mt-s anz-mt-0-sm anz-wf-mo anz-ml-auto anz-mr-auto"
        @click="subscribeUser"
        :loading="isSubscribingUser"
        :title="$translate('profile.actions.subscribeUser')"
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-class="anz-mr-xs"
        loader-class="anz-spinner-xxs"
      ></a-button>
    </template>
  </a-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import AButton from '@/components/Forms/AButton.vue'
import { useSubscribeUser } from '@/composables/subscribers/subscribersManager'
import { useRouter } from '@/routing/router'
import useCurrentUser from '@/composables/user/user'
import ATooltip from '@/components/Ui/ATooltip.vue'
import { Post } from '@/model/data-object/Post'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_SUBSCRIBE,
  emits: ['tooltip-close'],
  components: { ATooltip, AButton },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    return {
      ...useSubscribeUser(props.post.author.id ?? 0, props.post as Post),
      ...useRouter(),
      ...useCurrentUser(),
    }
  },
})
</script>
